export default {
    1: [
        'strategy_add',
        'strategy_edit',
        'strategy_reviewpass',
        'strategy_up',
        'strategy_reviewreset',
        'strategy_strategyremove',
        'strategy_stopprocess',
        'strategy_startprocess',
        'strategy_restartprocess',
        'label_set',
        'threshold_up_set',
        'threshold_down_set',
        'tab_operate',
        'user_add',
        'assetcheck_update'
    ],

    2: [
        'strategy_add',
        'strategy_edit',
        'strategy_reviewpass',
        'strategy_stopprocess',
        'strategy_startprocess',
        'strategy_restartprocess'
    ]
}



// WEBPACK FOOTER //
// ./src/lib/_authList.js